<template>
    <div class="order_box">
        <module-title title="我的订单"></module-title>
        <div class="order_list_box course_news_box">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部订单" name="0"></el-tab-pane>
                <el-tab-pane label="待支付" name="1"></el-tab-pane>
                <el-tab-pane label="已完成" name="2"></el-tab-pane>
                <el-tab-pane label="已取消" name="3"></el-tab-pane>
                <el-tab-pane label="已关闭" name="4"></el-tab-pane>
            </el-tabs>
            <!-- 订单列表 -->
            <personal-order>
                <personal-order-item
                    :orderType="item.status"
                    :businessType="item.businessType"
                    :orderID="item.id"
                    :invoiceInfo="item.invoiceInfo"
                    v-for="(item, index) in orderlist"
                    :key="index"
                >
                    <p class="order_date" slot="order_date">
                        {{ item.createDate }}
                    </p>
                    <div class="order_num" slot="order_num">
                        订单号：<span>{{ item.orderNumber }}</span>
                    </div>
                    <div class="order_type" slot="order_type">
                        订单类型：<span v-if="item.businessType == 0"
                            >培训报名</span
                        >
                    </div>
                    <img
                        src="~assets/images/temporary/ordertit_Img.jpg"
                        slot="userImg"
                        v-if="item.businessType === '0'"
                    />
                    <div class="order_course_name" slot="order_course_name">
                        <p v-if="item.businessType === '0'">
                            {{ item.categoryInfo.name }}
                        </p>
                        <p v-else>{{ item.courseInfo.name }}</p>
                    </div>
                    <div class="order_pay_num" slot="order_pay_num">X1</div>
                    <div class="user_name" slot="user_name">
                        {{ item.member.userName }}
                    </div>
                    <div class="order_price" slot="order_price">
                        {{ item.actualAmount }}
                    </div>
                    <span slot="order_type_p">
                        {{ orderStatusName(item.status) }}
                    </span>
                </personal-order-item>
            </personal-order>
            <!-- 暂无订单 -->
            <p class="noMessage" v-if="noMessage">暂无订单</p>
            <!-- 分页器 -->
            <div class="block page_box mtop20">
                <el-pagination
                    v-if="!noMessage"
                    layout="prev, pager, next"
                    :page-size="page.size"
                    :background="true"
                    :total="page.total"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import PersonalOrder from "@/components/contents/personalOrder/PersonalOrder";
import PersonalOrderItem from "@/components/contents/personalOrder/PersonalOrderItem";

import { PcCookie, Key } from "@/utils/cookie";

import { getOrderTimelist } from "api/order";
export default {
    components: { ModuleTitle, PersonalOrder, PersonalOrderItem },
    computed: {
        noMessage() {
            return this.page.total == 0 ? true : false;
        },
        orderStatusName() {
            return function (status) {
                let name = "";
                if (status == "0") {
                    name = "待支付";
                } else if (status == "1") {
                    name = "已取消";
                } else if (status == "2") {
                    name = "交易关闭";
                } else if (status == "3") {
                    name = "已完成";
                }
                return name;
            };
        },
    },
    data() {
        return {
            activeName: 0,
            page: {
                current: 1,
                size: 3,
                total: 0,
            },
            status: "", //订单状态
            itemId: "",
            orderlist: [], //订单列表
            cancelOrder: null,
            data: "",
            orderID: "",
        };
    },
    created() {
        this.fetchOrderList();
    },
    methods: {
        //获取订单列表
        fetchOrderList() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getOrderTimelist(
                sessionId,
                this.status,
                this.page.current,
                this.page.size
            ).then((res) => {
                if (res.errorCode === "2000") {
                    this.orderlist = res.body.data.rows;
                    this.page.total = res.body.data.total;
                }
            });
        },
        //切换订单状态选项
        handleClick(tab) {
            if (tab.name === "0") {
                this.status = "";
            } else if (tab.name === "1") {
                this.status = "0";
            } else if (tab.name === "2") {
                this.status = "3";
            } else if (tab.name === "3") {
                this.status = "1";
            } else {
                this.status = "2";
            }
            this.fetchOrderList();
        },
        //切换分页器
        handleCurrentChange(val) {
            //分页数切换
            this.page.current = val;
            this.fetchOrderList();
        },
    },
};
</script>
<style scoped>
.noMessage {
    height: 120px;
    line-height: 120px;
    font-size: 16px;
    color: #818181;
    text-align: center;
}
</style>
